import { useState, useEffect } from "react";
import { Box, Typography, Tooltip, IconButton, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseProduct4 } from "../UseProduct4";
import { useRecoilState } from "recoil";
import { rsProgress, rsParentCom } from "../../../../RecoilStates";
import CustomPagination from "../../../../components/CustomPagination";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import DeleteRow from "../../../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSnackbar } from "notistack";
import { useLocation } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";

export default function ProductsGrid(props) {
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const { deleteProductOfferGroup, UpdateProductOfferGroup } = UseProduct4();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [searchSubGroup, setSearchSubGroup] = useState("");
  const [filt, setFilt] = useState([]);
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);

  useEffect(() => {
    setFilt([
      {
        columnField: "productName",
        operatorValue: "contains",
        value: searchSubGroup,
      },
    ]);
  }, [searchSubGroup]);

  const newFunc = () => {
    if (props.offers && props.offers.id) {
      return navigate("/ProductsOfferManage/AddGroup", {
        state: {
          search: searchSubGroup,
          groupsLength: props.rows,
          thisOfferId: props.OfferID,
          componentFaTitle: location.state.componentFaTitle,
          OfferID: props.componentAID,
          parentUrl: msParentCom.parentComs,
        },
      });
    } else {
      enqueueSnackbar("ابتدا اطلاعات فوق را وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return;
    }
  };

  const columns = [
    {
      field: "rowIndex",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "id",
      width: 70,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      // hide: true,
    },
    {
      field: "title",
      headerName: "نام گروه",
      width: 230,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 140,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="حذف">
              <IconButton
                sx={{ p: 0.5, mr: 0.5 }}
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.title,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                sx={{ p: 0.5, mr: 0.5 }}
                onClick={() => {
                  return navigate("/ProductsOfferManage/EditGroup", {
                    state: {
                      search: searchSubGroup,
                      groupsLength: props.rows,
                      thisOfferId: props.OfferID,
                      componentFaTitle: location.state.componentFaTitle,
                      OfferID: props.componentAID,
                      model: cellValues.row,
                      allGroups: props.rows,
                      parentUrl: msParentCom.parentComs,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <IconButton
              sx={{ p: 0.5, mr: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  rowIndex: cellValues.row.rowIndex - 1,
                  aid: props.componentAID,
                  groupID: props.OfferID,
                };
                if (cellValues.row.rowIndex - 1 == 0) {
                  return;
                } else {
                  UpdateProductOfferGroup(model, "", "", () =>
                    props.callback()
                  );
                }
              }}
            >
              <ArrowDropUpIcon fontSize="small" sx={{}} />
            </IconButton>
            <IconButton
              sx={{ p: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  rowIndex: cellValues.row.rowIndex + 1,
                  aid: props.componentAID,
                  groupID: props.OfferID,
                };
                if (cellValues.row.rowIndex + 1 == props.rows.length + 1) {
                  return;
                } else {
                  UpdateProductOfferGroup(model, "", "", () =>
                    props.callback()
                  );
                }
              }}
            >
              <ArrowDropDownIcon fontSize="small" sx={{}} />
            </IconButton>
          </>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <TextField
            placeholder="جستجو گروه"
            size="small"
            variant="outlined"
            value={searchSubGroup}
            inputProps={{ "aria-label": "search" }}
            onChange={(evt) => {
              setSearchSubGroup(evt.target.value);
            }}
          />
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "30rem", mb: 5 }}>
      <DataGrid
        className="ltr-grid"
        filterModel={{
          items: filt,
        }}
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        rows={props.rows ? props.rows : []}
        page={pageState.page - 1}
        pageSize={20}
        Pagination
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...pageState, page: newPage + 1 }));
        }}
        rowCount={props.rows && props.rows.length ? props.rows.length : 1}
        disableColumnMenu
        hideFooterSelectedRowCount
        components={{
          Pagination: CustomPagination,
        }}
        componentsProps={{
          pagination: {
            newFunc: newFunc,
            // nofab: true,
            // isRefresh: true,
            isLtr: true,
            rowCount: props.rows && props.rows.length ? props.rows.length : "",
          },
        }}
        initialState={{
          sorting: {
            sortModel: [
              {
                field: "rowIndex",
                sort: "asc",
              },
            ],
          },
        }}
      />

      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"گروه"}
        callback={() => {
          setProgress(true);
          deleteProductOfferGroup(deleteState.id, () => {
            props.callback();
          });
        }}
      ></DeleteRow>
    </Box>
  );
}
